import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const licensingService = {
    getData: async () => axios.get(API_URL + "/licensing/data").then(({ data }) => data).catch((err) => { throw err }),
}

export default licensingService;